function __loadable_isReady__(self, props) {
  if (typeof __webpack_modules__ !== "undefined") {
    return !!__webpack_modules__[self.resolve(props)];
  }
  
  return false;
}
function __loadable_requireSync__(self, props) {
  var id = self.resolve(props);
  if (typeof __webpack_require__ !== 'undefined') {
    return __webpack_require__(id);
  }
  return eval('module.require')(id);
}
import loadable from '@loadable/component';
const MDEditorDynamic = loadable({
    chunkName() {
        return "CustomMDEditor";
    },
    isReady(props) {
        return __loadable_isReady__(this, props);
    },
    requireAsync: () => import(/* webpackChunkName: "CustomMDEditor" */ './CustomMDEditor'),
    requireSync(props) {
        return __loadable_requireSync__(this, props);
    },
    resolve() {
        return require.resolveWeak ? require.resolveWeak(/* webpackChunkName: "CustomMDEditor" */ './CustomMDEditor') : eval("require.resolve")(/* webpackChunkName: "CustomMDEditor" */ './CustomMDEditor');
    }
});
export default MDEditorDynamic;
